import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/UpdateUserProposalBreakdownMode.graphql';
import { Mutation, MutationupdateUserProposalBreakdownModeArgs } from '../../__generated__/globalTypes';

export const useUpdateUserProposalBreakdownModeMutation = (
  options?: MutationHookOptions<Mutation, MutationupdateUserProposalBreakdownModeArgs>
) => {
  const [callUpdateUserProposalBreakdownMode, result] = useMutation<
    Mutation,
    MutationupdateUserProposalBreakdownModeArgs
  >(MUTATION, options);

  return { callUpdateUserProposalBreakdownMode, ...result };
};

export type UpdateUserProposalBreakdownModeMutationFunction = Mutation['updateUserProposalBreakdownMode'];
